// vendors
import { useEffect, useState } from "react";
import { Stack, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ReactPlayer from "react-player";

// @ts-ignore
import parse from "html-react-parser";
import { theme } from "../../../../Customization/Theme";
import Icon from "../Icon";
import store from "../../../../Store/index";
import { convertWhatsappToHtmlText } from "../../Utils/editor";
import { getTruncatedFileName } from "../Editor/utils/common";

type URL = {
  url: string;
};

type MediaInfoType = {
  file?: URL;
  image?: URL;
  video?: URL;
  value?: any;
  type?: any;
};

interface MessagePreviewProps {
  text?: string;
  mediaDetails?: MediaInfoType;
  isMediaNode?: boolean;
  nodeType?: any;
}

const MessagePreviewStyled = styled(Box)<{ nodeType?: string }>(({ nodeType }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: theme.spacing(1.5),
  borderRadius: "4px",
  color: theme.palette?.default?.darkGrey,
  fontSize: "14px",
  lineHeight: "21px",
  fontWeight: 400,
  wordBreak: "break-word",
  height: nodeType === "share-location" ? "100%" : "auto",
  "& p": {
    margin: 0,
  },
}));


const MessagePreview = (props: MessagePreviewProps) => {
  const { mediaDetails, text, isMediaNode } = props;
  const [mediaURL, setMediaURL] = useState("");
  const [mediaURLType, setMediaURLType] = useState("");
  const [location, setLocation] = useState<any>();
  const currentBot = store.getState();
  const renderedText = currentBot?.userData?.dashboardData?.currentBot?.channel === "whatsapp" ? convertWhatsappToHtmlText(text || "") : text;
  const previewText = typeof renderedText === "string"
    ? renderedText.replace(/<p[^>]*>\s*<\/p>/gi, "<p><br/></p>")
    : renderedText;
  useEffect(() => {
    setMediaURL("");
    setMediaURLType("");
    if (!mediaDetails) return;

    if (isMediaNode) {
      const url = mediaDetails?.value?.url || "";
      const type = mediaDetails?.type || "";
      setMediaURL(url);
      setMediaURLType(type);
    } else {
      if(mediaDetails?.type === "share-location"){
        setLocation(mediaDetails?.value);
        setMediaURLType("share-location");
      }else{
        Object.entries(mediaDetails).forEach(([key, value]) => {
        if (value?.url && value.url !== "") {
          setMediaURL(value.url);
          setMediaURLType(key);
        }
      });
      }
    }
  }, [mediaDetails, isMediaNode]);

  return (
    <MessagePreviewStyled nodeType = {props?.nodeType}>
      {mediaURLType === "image" && (
        <Box
          component="img"
          src={mediaURL}
          sx={{ width: "100%", objectFit: "cover" }}
        />
      )}
      {mediaURLType === "video" && (
        <ReactPlayer
          url={mediaURL}
          width={"100%"}
          height="230px"
          controls={true}
        />
      )}
      {mediaURLType === "document" && mediaURL && (
          <Stack
            direction="row"
            spacing="16px"
            sx={{ px: "20px", py: "16px", width: "90%" }}
          >
            <Box>
              <Icon icon="document" size={24} color="#5B73E8" />
            </Box>
          <Typography
            color={"#5B73E8"}
            variant="body1"
            component={"a"}
            href={mediaURL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: "none", fontSize: "16px" }}
            title={mediaURL?.substring(mediaURL?.lastIndexOf('/') + 1)}
          >
            {getTruncatedFileName(mediaURL)}
          </Typography>
          </Stack>
        )
      }
      {
        mediaURLType === "share-location" &&(
          <LocationContainer>
              <iframe
                src={`https://maps.google.com/maps?q=${location.latitude},${location.longitude}&z=15&output=embed`}
                width="100%"
                height="200"
                style={{ border: 0, height: "76%" }}
                loading="lazy"
                title="Location Preview"
              ></iframe>
              <div style={{ padding: "10px" }}>
                <a href={location.url} target="_blank" rel="noreferrer" style={{ fontWeight: "bold", textDecoration: "none" }}>
                  {location.name}
                </a>
                <p style={{ margin: "6px 0", color: "#444", fontSize: "14px" }}>{location.address}</p>
              </div>
            </LocationContainer>
        )
      }
      <Typography
        sx={{
          fontSize: "14px",
          lineHeight: "21px",
          fontWeight: 400,
          color: "#7E8392",
          ...(mediaURLType !== "" && { mt: "12px" }),
        }}
        component="div"
      >
        {/* {text !== "" && typeof text === "string" && parse(text)} */}
        {previewText !== "" && typeof previewText === "string" && parse(previewText)}
      </Typography>
    </MessagePreviewStyled>
  );
};

export default MessagePreview;

const LocationContainer = styled("div")`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
`